module.exports = __webpack_public_path__ + "static/img/4.57f8336.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menthu/3/4.png
// module id = kZmo
// module chunks = 0